import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import {
  BsArrowDownLeft,
  BsArrowDownRight,
  BsArrowUpRight,
  BsCheckCircleFill,
  BsClockFill,
  BsXCircleFill,
} from "react-icons/bs";
import { DashboardBigChart, DashboardSmallChart } from "../components/Charts";
import {
  appointmentsData,
  dashboardCards,
  memberData,
  transactionData,
} from "../components/Datas";
import { Transactiontable } from "../components/Tables";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllStatistics,
  getStatistics,
} from "../redux/features/configurationSlice";
import { values } from "lodash";
import {
  FaCalendarAlt,
  FaFilePrescription,
  FaMoneyBillAlt,
} from "react-icons/fa";
import AddAttentionModal from "../components/Modals/AddAttentionModal";
import { getAllPatients, getPatients } from "../redux/features/patientSlice";
import { createCita, getCitas } from "../redux/features/citasSlice";
import ConfirmationAlert from "../components/ConfirmationAlert";
import { useNavigate } from "react-router-dom";

// En cualquier componente
import { useLogger } from "../customHooks/useLogger";

const CalendarIcon = () => (
  <FaCalendarAlt className="text-yellow-500 text-lg" />
);
const PrescriptionIcon = () => (
  <FaFilePrescription className="text-yellow-500 text-lg" />
);
const PaymentIcon = () => (
  <FaMoneyBillAlt className="text-yellow-500 text-lg" />
);

const idCards = ["total_patients", "total_citas", "total_payments"];
const valCards = ["patients_by_month", "citas_by_month", "payments_by_month"];

function Dashboard() {
  const statistics = useSelector(getAllStatistics);
  const { data: patients = [] } = useSelector(getAllPatients) || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getStatistics());
    dispatch(getPatients());
  }, [dispatch]);

  const [openAttention, setOpenAttention] = useState(false);

  // Función para manejar la operación similar a Appointments
  const handleOperation = {
    dispatch: dispatch,
    update: (updatedEvent) => {
      // Puedes implementar lógica de actualización local si es necesario
      console.log("Evento actualizado:", updatedEvent);
    },
  };

  return (
    <Layout>
      <h1 className="text-xl font-semibold mb-10">
        Sistema de Gestion de Pacientes
      </h1>

      {/* Botones de acción */}
      <div className="fixed bottom-6 right-6 flex flex-col gap-4 items-end z-50">
        <button
          onClick={() => setOpenAttention(true)}
          className="group flex items-center justify-center hover:justify-start bg-white border border-border rounded-full w-12 hover:w-48 h-12 transition-all duration-300 overflow-hidden shadow-sm hover:shadow-md relative"
        >
          <div className="flex items-center justify-center w-12 h-12 text-yellow-500 text-xl group-hover:absolute group-hover:left-0">
            <FaCalendarAlt />
          </div>
          <span className="absolute opacity-0 group-hover:opacity-100 group-hover:relative transition-opacity duration-300 text-sm font-medium text-gray-700 whitespace-nowrap left-12">
            Nueva Consulta
          </span>
        </button>

        {[
          /* {
            to: "/prescription",
            icon: <FaFilePrescription />,
            label: "Imprimir Receta",
          },
          {
            to: "/payments",
            icon: <FaMoneyBillAlt />,
            label: "Registrar Pago",
          }, */
        ].map(({ to, icon, label }) => (
          <Link
            to={to}
            key={label}
            className="group flex items-center justify-center hover:justify-start bg-white border border-border rounded-full w-12 hover:w-48 h-12 transition-all duration-300 overflow-hidden shadow-sm hover:shadow-md relative"
          >
            <div className="flex items-center justify-center w-12 h-12 text-yellow-500 text-xl group-hover:absolute group-hover:left-0">
              {icon}
            </div>
            <span className="absolute opacity-0 group-hover:opacity-100 group-hover:relative transition-opacity duration-300 text-sm font-medium text-gray-700 whitespace-nowrap left-12">
              {label}
            </span>
          </Link>
        ))}
      </div>

      {/* Gráficas */}
      <div className="w-full grid xl:grid-cols-3 gap-6 lg:grid-cols-3 sm:grid-cols-1 grid-cols-1">
        {dashboardCards.map((card, index) => (
          <div
            key={card.id}
            className="bg-white rounded-xl border-[1px] border-border p-5"
          >
            <div className="flex gap-4 items-center">
              <div
                className={`w-10 h-10 flex-colo bg-opacity-10 rounded-md ${card.color[1]} ${card.color[0]}`}
              >
                <card.icon />
              </div>
              <h2 className="text-sm font-medium">{card.title}</h2>
            </div>
            <div className="grid grid-cols-8 gap-4 mt-4 bg-dry py-5 px-8 items-center rounded-xl">
              <div className="col-span-5">
                <DashboardSmallChart
                  data={statistics[valCards[index]]?.map((val) => val.valor)}
                  colors={card.color[2]}
                />
              </div>
              <div className="flex flex-col gap-4 col-span-3">
                <h4 className="text-lg font-medium">
                  {statistics[idCards[index]] ?? ""}
                  {card.id === 4 ? "Bs" : "+"}
                </h4>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="w-full my-6 grid xl:grid-cols-8 grid-cols-1 gap-6">
        <div className="xl:col-span-8 w-full">
          <div className="bg-white rounded-xl border-[1px] border-border p-5">
            <div className="mt-4">
              <h2 className="text-sm font-medium">Pacientes por Mes</h2>
              <DashboardBigChart datos={statistics?.patients_by_month} />
            </div>
          </div>
        </div>
      </div>

      {/* Modal de Atención */}
      {openAttention && (
        <AddAttentionModal
          isOpen={openAttention}
          closeModal={() => setOpenAttention(false)}
          patients={patients}
          operation={handleOperation}
        />
      )}
    </Layout>
  );
}

export default Dashboard;
